/* assets/gift-reveal.js
 * NoWhey standalone gift-reveal lander — <gift-reveal> Web Component.
 * State machine: tap -> email -> reveal. Progressive enhancement over a native
 * Shopify customer form, so email capture still works with JS disabled.
 * Legal: guaranteed gift, outcome pre-assigned. Never surface chance/luck/win language.
 */
(function () {
  'use strict';

  if (customElements.get('gift-reveal')) return;

  class GiftReveal extends HTMLElement {
    connectedCallback() {
      this.code = this.dataset.code || '';
      this.shopUrl = this.dataset.shopUrl || '/collections/all';
      this.giftVariant = this.dataset.giftVariant || '';
      this.panels = {
        tap: this.querySelector('[data-panel="tap"]'),
        email: this.querySelector('[data-panel="email"]'),
        reveal: this.querySelector('[data-panel="reveal"]')
      };
      this.form = this.querySelector('.gr-form');
      this.emailInput = this.querySelector('[data-email]');
      this.errorEl = this.querySelector('[data-error]');
      this.submitBtn = this.querySelector('[data-submit]');

      // After a native form submit the page reloads; show the reveal state then.
      // sessionStorage flag survives the reload (and any captcha challenge round-trip);
      // ?customer_posted=true is Shopify's own success signal as a secondary check.
      var pending = false;
      try { pending = sessionStorage.getItem('gr_pending') === '1'; } catch (e) {}
      if (pending || /[?&]customer_posted=true/.test(window.location.search)) {
        try { sessionStorage.removeItem('gr_pending'); } catch (e) {}
        this.applyDiscount();
        this.go('reveal');
      }

      this.querySelectorAll('[data-unlock]').forEach(function (btn) {
        btn.addEventListener('click', this.onUnlock.bind(this));
      }, this);

      if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));

      var shopBtn = this.querySelector('[data-shop]');
      if (shopBtn) shopBtn.addEventListener('click', this.onShop.bind(this));

      var copy = this.querySelector('[data-copy-code]');
      if (copy) {
        var copyFn = this.copyCode.bind(this);
        copy.addEventListener('click', copyFn);
        copy.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); copyFn(); }
        });
      }
    }

    go(state) {
      this.dataset.state = state;
      Object.keys(this.panels).forEach(function (key) {
        var el = this.panels[key];
        if (!el) return;
        el.hidden = key !== state;
      }, this);
      if (state === 'email' && this.emailInput) {
        try { this.emailInput.focus(); } catch (e) {}
      }
    }

    onUnlock(e) {
      e.preventDefault();
      this.go('email');
    }

    validEmail(v) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((v || '').trim());
    }

    onSubmit(e) {
      // Native submit (NOT fetch): the Shopify customer form carries its captcha token,
      // which a scripted fetch strips (tripping the /challenge page). We validate the
      // email, flag the pending state, then let the form POST normally. The page reloads
      // and connectedCallback shows the reveal + applies the discount.
      if (!this.emailInput || !this.validEmail(this.emailInput.value)) {
        e.preventDefault();
        if (this.errorEl) this.errorEl.textContent = 'Please enter a valid email so we can lock in your gift.';
        return;
      }
      try { sessionStorage.setItem('gr_pending', '1'); } catch (err) {}
      if (this.submitBtn) { this.submitBtn.disabled = true; this.submitBtn.textContent = 'Unlocking…'; }
      // do not preventDefault — allow the native POST to proceed
    }

    onShop(e) {
      // Put the free gift in the cart so it actually lands (BXGY only zeroes it once it's
      // in-cart AND the $89 minimum is met — below $89 it stays full price, so no abuse),
      // apply the code, then send them to shop to build their qualifying order.
      var href = e.currentTarget.getAttribute('href');
      if (!this.giftVariant) return; // no variant configured -> just follow the link
      e.preventDefault();
      var self = this;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(this.giftVariant), quantity: 1 }] }),
        credentials: 'same-origin'
      }).then(function () { return self.applyDiscount(); })
        .catch(function () {})
        .then(function () { window.location.href = href; })
        .catch(function () { window.location.href = href; });
    }

    applyDiscount() {
      if (!this.code) return Promise.resolve();
      // Apply the code to the cart session so it carries through to checkout even if the
      // URL param is dropped. The BXGY code zeroes the gift only at $89+, one per customer.
      return fetch('/discount/' + encodeURIComponent(this.code), { credentials: 'same-origin' })
        .catch(function () {});
    }

    copyCode() {
      if (!this.code || !navigator.clipboard) return;
      var el = this.querySelector('[data-code-text]');
      navigator.clipboard.writeText(this.code).then(function () {
        if (!el) return;
        var original = el.textContent;
        el.textContent = 'Copied!';
        setTimeout(function () { el.textContent = original; }, 1400);
      }).catch(function () {});
    }
  }

  customElements.define('gift-reveal', GiftReveal);
})();
